import React, { RefObject } from 'react'
import PropTypes from 'prop-types'
import { AppStorage } from './storage'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { ViewStyle, Dimensions, StyleSheet, Text, ScrollView, View, StatusBar, Platform, StyleProp, LayoutChangeEvent } from 'react-native'
import { treeDataPartner } from '../../app-editor/src/tree-data-partner.js'
import { treeDataFisher } from '../../app-editor/src/tree-data-fisher.js'
import { key_sku } from './key_sku'
import { GearIcon } from './gear'
import { SettingsMenu } from './settings-menu'
import Header from './header'
import { ZoomedImage } from './zoomed-image'
import { ZoomHoverBoxPosition } from './zoomed-hover-box'
import DesktopHeader from './desktop-header'
import { isPortrait } from '../orientation'
import { ConfiguratorV2CTN } from './configurator-ctn'
import { RequestQuoteCart } from './request-quote-cart'
import { Config } from '../config'
import { REACT_NATIVE_API, REACT_NATIVE_APIV2 } from '../constants'
import axios from 'axios'
import version from '../../app-editor/src/version.json'
import { CatalogUpdate } from './CatalogUpdate'
import { isMobile } from 'react-device-detect'
// isMobile defines what device the user is on in the web browser. If that returns undefined, then the user is not on a browser at all, and therefore must be on the mobile app.
let onMobileApp = false;
if (isMobile === undefined) {
  onMobileApp = true;
}

function csvJSON(csv: string) {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");

  for (var i = 1; i < lines.length; i++) {
    const map = new Map<string, string>()
    var currentline = lines[i].split(",");

    for (var j = 0; j < headers.length; j++) {
      headers[j] = headers[j].replace(/"/g, "")
      for (var k = 0; k < currentline.length; k += 1) {

        const line = currentline[k].replace(/"/g, "")
        currentline[k] = line
      }
      map.set(headers[j], currentline[j])
    }

    result.push(map);
  }

  return result
}

console.log("PARSING KEY SKU TO JSON")
const key_sku_table = csvJSON(key_sku)

type BuildAChairAppProps = {
  config: Config,
  onLogOut: Function,
}

type BuildAChairAppState = {
  sku: string | null,
  customSKU: string | null,
  showRoot: boolean,
  height: number,
  color: string | null,
  scrollOffset: number,
  scrollViewHeight: number,
  coverPageOpen: boolean,
  loading: boolean,
  orientation: string,
  headerHeight: number,
  settingsOpen: boolean,
  treeData: Array<Object>,
  initSKU: string | null,
}

export class BuildAChairApp extends React.Component<BuildAChairAppProps, BuildAChairAppState> {
  static propTypes = {
    config: PropTypes.object,
    onLogOut: PropTypes.func,
  }

  scrollViewRef: RefObject<ScrollView>

  constructor(props: BuildAChairAppProps) {
    super(props)

    this.state = {
      sku: null,
      customSKU: null,
      showRoot: true,
      height: 500,
      color: null,
      scrollOffset: 0.0,
      scrollViewHeight: 1.0,
      coverPageOpen: false,
      loading: true,
      orientation: 'portrait',
      headerHeight: 0,
      settingsOpen: false,
      zoomedImageOpen: false,
      zoomHoverBoxPosition: { top: 0, left: 0 },
      imageSize: { width: 0, height: 0 },
      rfqCartOpen: false,
      treeData: JSON.parse(this.props.config.catalog === 'fisher' ? treeDataFisher : treeDataPartner),
      initSKU: '',
    }

    const boxHeight = 300
    const boxWidth = boxHeight * 0.8

    this.boxHeight = boxHeight
    this.boxWidth = boxWidth

    this.scrollViewRef = React.createRef()
    this.imgRef = React.createRef()

    this.setSKU = this.setSKU.bind(this)
    this.toggleLoading = this.toggleLoading.bind(this)
    this.onSettingsPress = this.onSettingsPress.bind(this)
    this.onZoomHoverBoxPositionChange = this.onZoomHoverBoxPositionChange.bind(this)
    this.onZoomHoverBoxOpenChange = this.onZoomHoverBoxOpenChange.bind(this)
    this.openQuoteCart = this.openQuoteCart.bind(this)
    this.onDeleteCartItem = this.onDeleteCartItem.bind(this)
    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.checkForCatalogChange = this.checkForCatalogChange.bind(this)
    this.setInitSKU = this.setInitSKU.bind(this)
    // tp = Third Party. This sectionn is for functions that are run when the app is a third party service
    this.tpCheckForCatalogChange = this.tpCheckForCatalogChange.bind(this)
    this.tpOpenQuoteCart = this.tpOpenQuoteCart.bind(this)
    this.tpOnDeleteCartItem = this.tpOnDeleteCartItem.bind(this)
    this.tpOnQuantityChange = this.tpOnQuantityChange.bind(this)
    // Helper function to pull description
    this.fetchDescription = this.fetchDescription.bind(this)
  }

  componentDidMount() {
    console.log(onMobileApp);
    if (navigator.cookieEnabled || onMobileApp) {
      this.checkForCatalogChange(this.props.config.catalog)
    } else if (!onMobileApp) {
      this.tpCheckForCatalogChange(this.props.config.catalog)
    }
    this.fetchCustomSKU()
    this.fetchColor()
    this.scrollbarColor(this.props.config.accentColor)

    this.setState({ orientation: (isPortrait() ? 'portrait' : 'landscape') })
    this.setState({ imageSize: this.getImageSize() })
    Dimensions.addEventListener('change', () => {
      this.setState({ orientation: (isPortrait() ? 'portrait' : 'landscape') })
      this.setState({ imageSize: this.getImageSize() })
    })
  }

  componentDidUpdate(_: any, prevState: BuildAChairAppState) {
    if (this.state.sku !== prevState.sku) {
      this.fetchColor()
      this.fetchCustomSKU()
    }
  }

  scrollbarColor(color: string) {
    if (Platform.OS === 'web') {
      const sheet = window.document.styleSheets[0];
      sheet.insertRule(
        `
::-webkit-scrollbar              { border-radius: 30px; }
`, sheet.cssRules.length);
      sheet.insertRule(
        `
::-webkit-scrollbar              { background-color: rgb(238, 238, 238); }
`, sheet.cssRules.length);
      sheet.insertRule(
        `
::-webkit-scrollbar-thumb { background-color: ${color}; }
`, sheet.cssRules.length);
      sheet.insertRule(
        `
::-webkit-scrollbar-thumb { border-radius: 30px; }
`, sheet.cssRules.length);
    }
  }

  toggleLoading() {
    this.setState(prevState => {
      return { loading: !prevState.loading }
    })
  }

  setSKU(sku: string) {
    this.setState({ sku: sku, showRoot: false })
  }

  fetchColor() {
    // Fetch options for sku
    const id = this.state.sku
    // const baseURL = process.env.REACT_NATIVE_API
    const baseURL = REACT_NATIVE_API

    if (id === null) {
      return
    }

    fetch(baseURL + '/color.php?sku=' + id)
      .then(res => res.json())
      .then(res => {
        if (res) {
          this.setState({ color: res })
        }
      }).catch(error => console.log({ error }))
  }

  async tpCheckForCatalogChange(catalog: string) {
    // postmessage to pms netlify with contents checkCatalog
    if (this.props.config.catalog === 'fisher') {
      const message = { method: 'Fisher', payload: null }
      window.parent.postMessage(message, `${document.referrer}`)
      console.log('fisher')
    } else if (this.props.config.catalog === 'partner') {
      const message = { method: 'Partner', payload: null }
      window.parent.postMessage(message, `${document.referrer}`)
      console.log('partner')
    }
    // define handler
    const handler = (event: any) => {
      // if event's origin is the same as our config host
      if (`${event.origin}/` == `${document.referrer}` && event.data.method == 'treeData') {
        // set our treeData state to the result (we made need to parse it if it is sent as json)
        const data = event.data.payload.treeData
        this.setState({ treeData: data })
        // call the toggle loading function
        this.toggleLoading()
        // remove the event listener
        removeEventListener('message', handler)
        // return
        return
      }
    }
    // add a event listener for messages
    window.addEventListener('message', handler)
    return
  }

  async checkForCatalogChange(catalog: string) {
    let fatalErr = false
    const res = await axios.get(`${REACT_NATIVE_APIV2}/server.php/api/version`)
      .catch((e) => {
        console.log(e)
        fatalErr = true
      })
    if (fatalErr) {
      await AppStorage.getItem(this.props.config.catalog)
        .then((obj) => {
          let localCatalog = JSON.parse(obj)
          if (localCatalog) {
            if (typeof localCatalog == 'string') {
              localCatalog = JSON.parse(localCatalog)
            }
            this.setState({ treeData: localCatalog })
          }
        })
        .catch((e) => {
          console.log(e)
        })
      this.toggleLoading()
      return
    }
    let currentVersion = version[this.props.config.catalog]
    const storedVer = await AppStorage.getItem(`${this.props.config.catalog}Version`)
    if (storedVer) {
      currentVersion = storedVer
    }
    const data = JSON.parse(res.data);
    if (currentVersion != data[this.props.config.catalog]) {
      AppStorage.setItem(`${this.props.config.catalog}Version`, JSON.stringify(data[this.props.config.catalog]))
      axios.get(`${REACT_NATIVE_APIV2}/server.php/api/${this.props.config.catalog}`)
        .then((response) => {
          const data = response.data
          this.setState({ treeData: JSON.parse(data) })
          this.toggleLoading()
          AppStorage.setItem(this.props.config.catalog, JSON.stringify(data))
        })
        .catch((e) => console.log(e))
      return
    }
    await AppStorage.getItem(this.props.config.catalog)
      .then((obj) => {
        let localCatalog = JSON.parse(obj)
        if (localCatalog) {
          if (typeof localCatalog == 'string') {
            localCatalog = JSON.parse(localCatalog)
          }
          this.setState({ treeData: localCatalog })
        }
      })
      .catch((e) => {
        console.log(e)
      })
    this.toggleLoading()
  }

  async fetchCustomSKU() {
    if (this.state.sku && this.props.config) {
      try {
        const baseURL = REACT_NATIVE_APIV2
        const res = await fetch(baseURL + '/server.php/api/custom-sku?sku=' + this.state.sku + '&partner=' + this.props.config.partner)
        const customSKUs = await res.json()
        console.log('HELLO THIS IS THE CUSTOM SKU ' + customSKUs);

        if (customSKUs.length > 0) {

          if (customSKUs[0] == ' | ') {
            this.setState({ customSKU: null })
          } else if (customSKUs.includes('Special Order') && this.props.config.catalog === 'fisher') {
            this.setState({ customSKU: customSKUs })
          } else {
            this.setState({ customSKU: customSKUs[0] })
          }
        }

      } catch (error) {
        console.log({ error })
      }
    }
  }

  setInitSKU(sku: string) {
    this.setState(prevState => ({ initSKU: sku }))
  }

  onSettingsPress(e: any) {
    this.setState(state => ({ settingsOpen: !state.settingsOpen }))
  }

  storeAuthPartner = async (value: string | null) => {
    if (value === null) {
      try {
        await AsyncStorage.removeItem('@auth_code')
      } catch (error) {
        console.log({ error })
      }
    } else {
      try {
        await AsyncStorage.setItem('@auth_code', value!)
      } catch (e) {
        console.log({ e })
      }
    }
  }

  getImageSize = () => {
    const height = Dimensions.get('window').height
    const maxHeight = height < 700 ? height < 500 ? 300 : 450 : 650
    const width = Math.floor(maxHeight * 0.8)
    return { width: width, height: maxHeight }
  }

  getHoverBoxPosition = () => {
    const position = { left: this.state.zoomHoverBoxPosition.left, top: this.state.zoomHoverBoxPosition.top }
    position.left = this.getLeftOffset(position)
    position.top = this.getTopOffset(position)
    return position
  }

  getLeftOffset = (position: ZoomHoverBoxPosition) => {
    if (position.left <= this.boxWidth / 2) {
      return 0
    } else if (position.left >= this.state.imageSize.width - this.boxWidth / 2) {
      return this.state.imageSize.width - this.boxWidth
    } else {
      return position.left - this.boxWidth / 2
    }
  }

  getTopOffset = (position: ZoomHoverBoxPosition) => {
    if (position.top <= this.boxHeight / 2) {
      return 0
    } else if (position.top >= this.state.imageSize.height - this.boxHeight / 2) {
      return this.state.imageSize.height - this.boxHeight
    } else {
      return position.top - this.boxHeight / 2
    }
  }

  onZoomHoverBoxOpenChange = (open: boolean) => {
    this.setState({ zoomedImageOpen: open })
  }

  onZoomHoverBoxPositionChange = (position: ZoomHoverBoxPosition) => {
    this.setState({ zoomHoverBoxPosition: position })
  }

  tpOnDeleteCartItem = async (sku: string) => {
    const message = { method: 'Delete Item', payload: { sku: sku } }
    window.parent.postMessage(message, `${document.referrer}`)
    return
  }

  onDeleteCartItem = async (sku: string) => {
    const cart = JSON.parse(await AsyncStorage.getItem("@rfqCart"))
    const newCart = cart.filter(item => item.sku != sku)
    if (newCart?.length > 0) {
      await AppStorage.setItem("@rfqCart", JSON.stringify(newCart))
    } else {
      await AppStorage.removeItem("@rfqCart")
    }
  }

  async fetchDescription (sku: string): Promise<string | null> {
    try {
      const baseURL = REACT_NATIVE_API
      const res = await fetch(baseURL + '/description.php?part=' + sku + '&catalog=' + this.props.config.catalog)
      const text = await res.json()
      return text
    } catch (error) {
      console.log({ error })
      return null
    }
  }

  tpOpenQuoteCart = async (open: boolean) => {
    const description = await this.fetchDescription(this.state.sku)
    const message = { method: 'Open Cart', payload: { sku: this.state.sku, description: description, quantity: 1 } }
    window.parent.postMessage(message, `${document.referrer}`)
    const handler = async (event: any) => {
      // if event's origin is the same as our config host
      if (`${event.origin}/` == `${document.referrer}` && event.data.method == 'Open Cart') {
        this.setState({ rfqCartOpen: open })
        // remove the event listener
        removeEventListener('message', handler)
        return
      }
      return
    }
    window.addEventListener('message', handler)
  }
  openQuoteCart = async (open: boolean) => {
    if (navigator.cookieEnabled) {
      const cartJSON = await AppStorage.getItem("@rfqCart")
      const cart = JSON.parse(cartJSON)
      const description = await this.fetchDescription(this.state.sku)

      if (cart == null) {
        await AppStorage.setItem("@rfqCart", JSON.stringify([{ sku: this.state.sku, description: description, quantity: 1 }]))

      } else {

        if (cart.find(item => item.sku == this.state.sku) == undefined) {
          cart.push({ sku: this.state.sku, description: description, quantity: 1 })
          await AppStorage.setItem("@rfqCart", JSON.stringify(cart))
        }

      }

      this.setState({ rfqCartOpen: open })
    } else {
      this.tpOpenQuoteCart(open)
    }
  }

  tpOnQuantityChange = async (sku: string, value: number) => {
    const message = { method: 'Change Quantity', payload: { sku: sku, value: value } }
    window.parent.postMessage(message, `${document.referrer}`)
    return
  }

  onQuantityChange = async (sku: string, value: number) => {
    const cartJSON = await AppStorage.getItem("@rfqCart")
    const cart = JSON.parse(cartJSON)

    if (cart != null) {

      if (cart.find(item => item.sku == sku) != undefined) {
        cart.find(item => item.sku == sku).quantity = value
        await AppStorage.setItem("@rfqCart", JSON.stringify(cart))
      }

    }
  }

  render() {
    const desktopContainer = {
      width: '100%',
      height: Platform.OS === 'web' ? '100vh' : Dimensions.get('window').height,
      margin: 'auto',
      overflow: 'hidden',
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'flex-start',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    }

    if (isPortrait()) {
      return (
        <View style={styles.mobileContainer}>
          <StatusBar
            animated={true}
            barStyle={'dark-content'}
          />
          {
            this.state.rfqCartOpen &&
            <View
              style={{ position: 'fixed', zIndex: 1000 }}
            >
              <RequestQuoteCart
                partner={this.props.config.partner}
                onQuantityChange={this.onQuantityChange}
                onDeleteCartItem={this.onDeleteCartItem}
                extraAttributes={this.props.config.extraAttributes ?? {}}
                onClose={e => this.setState(state => ({ rfqCartOpen: !state.rfqCartOpen }))}
              />
            </View>
          }
          <ScrollView
            scrollEventThrottle={1}
            ref={this.scrollViewRef}
            style={styles.scrollView as StyleProp<ViewStyle>}
            contentContainerStyle={styles.scrollView}
            keyboardShouldPersistTaps={"always"}
          >
            {
              this.state.settingsOpen &&
              <SettingsMenu onSignOut={() => {
                this.storeAuthPartner(null)
                this.props.onLogOut()
              }} />
            }
            {
              Platform.OS !== 'web' &&
              <View
                style={styles.gear}
              >
                <GearIcon onPress={this.onSettingsPress} />
              </View>
            }
            <Header
              onLayout={(e: LayoutChangeEvent) => this.setState({ headerHeight: e.nativeEvent.layout.height })}
            />
            <ConfiguratorV2CTN
              customSKU={this.state.customSKU}
              catalog={this.props.config.catalog}
              partner={this.props.config.partner}
              displayName={this.props.config.displayName}
              accentColor={this.props.config.accentColor}
              headerHeight={this.state.headerHeight}
              scrollViewRef={this.scrollViewRef}
              onSetSKU={this.setSKU}
              showProductDisplay={true}
              color={this.state.color}
              openQuoteCart={this.openQuoteCart}
              treeData={this.state.treeData}
              keySKUTable={key_sku_table}
              host={this.props.config.host}
              extraAttributes={this.props.config.extraAttributes ?? {}}
              initSKU={this.state.initSKU}
              setInitSKU={this.setInitSKU}
            />
          </ScrollView>
          {!onMobileApp && this.state.loading && <CatalogUpdate isVisible={this.state.loading} />}
        </View>
      )
    } else {
      return (
        <View style={desktopContainer as StyleProp<ViewStyle>}>
          {
            this.state.zoomedImageOpen &&
            <ZoomedImage
              sku={this.state.sku}
              normalizedPosition={{
                top: this.getHoverBoxPosition().top / this.state.imageSize.height,
                left: this.getHoverBoxPosition().left / this.state.imageSize.width,
                width: this.boxWidth / this.state.imageSize.width,
                height: this.boxHeight / this.state.imageSize.height
              }}
              imgRef={this.imgRef}
            />
          }
          {
            this.state.rfqCartOpen &&
            <View
              style={{ position: 'fixed', zIndex: 1000 }}
            >
              <RequestQuoteCart
                partner={this.props.config.partner}
                onQuantityChange={this.onQuantityChange}
                tpOnQuantityChange={this.tpOnQuantityChange}
                onDeleteCartItem={this.onDeleteCartItem}
                tpOnDeleteCartItem={this.tpOnDeleteCartItem}
                extraAttributes={this.props.config.extraAttributes ?? {}}
                onClose={e => this.setState(state => ({ rfqCartOpen: !state.rfqCartOpen }))}
              />
            </View>
          }
          <ScrollView keyboardShouldPersistTaps={"always"} scrollEventThrottle={1} ref={this.scrollViewRef} showsVerticalScrollIndicator={true} style={{ height: '100%', width: '100%' }} contentContainerStyle={Platform.OS === 'web' ? { width: '100%', height: '100%' } : { width: '100%' }}>
            <ConfiguratorV2CTN
              customSKU={this.state.customSKU}
              catalog={this.props.config.catalog}
              partner={this.props.config.partner}
              displayName={this.props.config.displayName}
              showProductDisplay={false}
              onSetSKU={this.setSKU}
              accentColor={this.props.config.accentColor}
              color={this.state.color}
              scrollViewRef={this.scrollViewRef}
              headerHeight={this.state.headerHeight}
              openQuoteCart={this.openQuoteCart}
              treeData={this.state.treeData}
              keySKUTable={key_sku_table}
              host={this.props.config.host}
              extraAttributes={this.props.config.extraAttributes ?? {}}
              initSKU={this.state.initSKU}
              setInitSKU={this.setInitSKU}
            />
          </ScrollView>
          <View style={{ width: 1, backgroundColor: '#AAA', height: '90%', marginTop: '2.5%', marginBottom: '2.5%' }}></View>
          <DesktopHeader
            zoomedImgRef={this.imgRef}
            customSKU={this.state.customSKU}
            onSettingsPress={this.onSettingsPress}
            accentColor={this.props.config.accentColor}
            color={this.state.color}
            showRoot={this.state.showRoot}
            sku={this.state.sku}
            onZoomHoverBoxOpenChange={this.onZoomHoverBoxOpenChange}
            onZoomHoverBoxPositionChange={this.onZoomHoverBoxPositionChange}
            partner={this.props.config.partner}
          />
          {!onMobileApp && this.state.loading && <CatalogUpdate isVisible={this.state.loading} />}

        </View>
      )
    }
  }
}

const styles = StyleSheet.create({
  gear: {
    position: 'absolute',
    top: 60,
    left: 20,
    zIndex: 100,
  },
  mobileContainer: {
    height: '100%',
    backgroundColor: '#fff'
  },
})

